import { RootState } from '../../../../../init-store';

export const selectResolvedUri = (state: RootState) => state.call.conference.config?.resolved_uri;

export const selectSlots = (state: RootState) => state.call.conference.slots;
